import React from 'react';
import { formatHighlightType } from './helpers';

const HighlightPreview = ({ highlight }) => (
  <div className="highlight-preview">
    <div className="preview-badge">{formatHighlightType(highlight.highlight_type)}</div>
    <div className="preview-info">
      <span className="preview-player">{highlight.player_name}</span>
      <span className="preview-round">Round {highlight.round_number}</span>
      <span className="preview-kills">{highlight.kills} kills</span>
    </div>
  </div>
);

export default HighlightPreview;
